import { Injectable } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation';
import { LocalStorage } from './local-storage.class';

@Injectable()
export class GpsService {
    public async getCurrentPosition(): Promise<object> {
        await Geolocation.requestPermissions().catch(() => {});
        const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: true });
        LocalStorage.setLatestLocation(position.coords);
        return position.coords;
    }
}
